<template>
  <ModalConfirmAlert id="modalNewMailsDeleteAlert" :message="msgAlert" />
</template>

<script>
import { mapState, mapActions } from "vuex";
import ModalConfirmAlert from "/src/components/modals/ModalConfirmAlert.vue";
import { mixinModal } from "/src/mixins";
import { deleteNewMailList } from "/src/service/new-mail.service.js";

export default {
  name: "NewMailsDelete",
  components: {
    ModalConfirmAlert,
  },
  mixins: [mixinModal],
  data() {
    return {
      dataDeleteMails: false,
      msgAlert: "",
      msgSuccsess: "メールを削除しました。",
      msgFail: "サーバにはエラーが発生しました。",
      interval: null,
    };
  },
  computed: {
    ...mapState("newMails", ["actionDeleteMails"]),
  },
  watch: {
    actionDeleteMails() {
      this.getDataDeleteMails();
    },
  },
  created() {
    this.getDataDeleteMails();
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    ...mapActions("alertMessage", ["showAlert"]),
    ...mapActions("newMails", ["setActionDeleteMails", "setStatusDeleteMails"]),
    getDataDeleteMails() {
      let isDeleteMails = localStorage.getItem("deleteNewMailsStatus");
      if (isDeleteMails == "true") {
        this.dataDeleteMails = true;
      } else {
        this.dataDeleteMails = false;
      }
      this.setStatusDeleteMails(this.dataDeleteMails);
      this.getApi(this.dataDeleteMails);
    },
    getNewMailsTask() {
      let body = {};
      let mailsBody = JSON.parse(localStorage.getItem("deleteNewMailsBody"));
      if (mailsBody) body = mailsBody;
      deleteNewMailList(body)
        .then((res) => {
          if (res.data.status == "finished") {
            this.msgAlert = this.msgSuccsess;
            this.stopGetApi();
            if (res.data.response) {
              if (res.data.response.error) this.msgAlert = this.msgFail;
            }
            this.showModal("modalNewMailsDeleteAlert");
            setTimeout(() => {
              this.closeModal("modalNewMailsDeleteAlert");
            }, 10000);
          }
        })
        .catch((response) => {
          if (response.response.status != 504) {
            this.stopGetApi();
          }
        });
    },
    getApi(isDeleteMails) {
      if (isDeleteMails && this.interval == null) {
        if (this.dataDeleteMails) this.getNewMailsTask();
        this.interval = setInterval(() => {
          if (this.dataDeleteMails) this.getNewMailsTask();
        }, 30000);
      }
    },
    stopGetApi() {
      localStorage.setItem("deleteNewMailsStatus", false);
      this.setActionDeleteMails(false);
      this.setStatusDeleteMails(false);
      clearInterval(this.interval);
      this.interval = null;
    },
  },
};
</script>
